// extracted by mini-css-extract-plugin
export default {"question":"Question_question__GhFQv","qtitle":"Question_qtitle__f6Msd"};